import React, { useState, useEffect } from 'react';
import TextInput from '../../common/components/TextInput/TextInput';
import TextArea from '../../common/components/TextArea/TextArea';
import ImageUpload from '../../common/components/ImageUpload/ImageUpload';
import styles from './AddressTemplate.module.css';
import Stepper from '../../common/components/Stepper/Stepper';
import Button from '../../common/components/Button/Button';

const AddressTemplate = ({
  userPrompt,
  onUserPromptChange,
  onhandleInputChange,
  onApplyChanges,
  heading,
  description,
  header1,
  header2,
  bannerDesc,
  bannerButton,
  workflowId,
  onImageUpload,
}) => {
  const [state, setState] = useState({
    selectedImage: null,
    heading: heading,
    description: description,
    header1: header1,
    header2: header2,
    bannerDesc: bannerDesc,
    bannerButton: bannerButton,
  });
  const steps = [
    { label: 'Home', path: '/' },
    { label: 'Workflow', path: `/workflow/${workflowId}` },
    { label: 'CheckS For Service', path: '' },
  ];
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (userPrompt && userPrompt.length > 0) {
      setIsVisible(false);
    }
  }, [userPrompt]);

  useEffect(() => {
    setState({
      selectedImage: null,
      heading: heading,
      description: description,
      header1: header1,
      header2: header2,
      bannerDesc: bannerDesc,
      bannerButton: bannerButton,
    });
  }, [heading, description, header1, header2, bannerDesc, bannerButton]);

  const handleInputChange = (key) => (e) => {
    const updatedState = { ...state, [key]: e.target.value };
    setState(updatedState);
    onhandleInputChange(key, e.target.value);
  };

  const handleApplyChanges = () => {
    onApplyChanges();
  };

  const showPrompt = () => {
    setIsVisible(!isVisible);
  };
  return (
    <div className={styles.container}>
      <Stepper steps={steps} workflowId={workflowId} />
      <TextArea
        label="Modify design with prompts"
        value={userPrompt}
        onChange={onUserPromptChange}
        placeholder="Describe additional changes (e.g., make h1 text larger)"
        showSuggestion={isVisible}
        onSuggestionToggle={showPrompt}
      />
      <div className={styles.prompts} onClick={showPrompt}>
        View sample prompts
      </div>
      <div className={styles.buttonContainer}>
        <div className={styles.buttonGroup}>
          <Button label="Apply Changes" onClick={handleApplyChanges} />
        </div>
      </div>
      <ImageUpload
        label="Change background Image"
        onChange={(file) => {
          setState({ ...state, selectedImage: file });
          //onUserPromptChange('selectedImage', file);
          onImageUpload(file); // Explicitly return the image to the parent
        }}
      />

      {[
        {
          key: 'heading',
          label: 'Header',
          placeholder: 'Ready to find your perfect plan?',
        },
        {
          key: 'description',
          label: 'Description',
          placeholder: "Tell us where you're based and we'll show",
        },
        {
          key: 'header1',
          label: 'Banner Header H1',
          placeholder: 'Internet Packages',
        },
        {
          key: 'header2',
          label: 'Banner Header H2',
          placeholder: 'Residential High-Speed Internet: Fast &',
        },
        {
          key: 'bannerDesc',
          label: 'Banner Description',
          placeholder: "Don't let sluggish internet speeds slow",
        },
        {
          key: 'bannerButton',
          label: 'Banner Button',
          placeholder: 'Shop Internet',
        },
      ].map(({ key, label, placeholder }, index) => (
        <TextInput
          key={index}
          label={label}
          value={state[key]}
          onChange={handleInputChange(key)}
        />
      ))}
    </div>
  );
};

export default AddressTemplate;
